import React, { useState } from "react";
import { PatientEntityType } from "@/lib/supabase/supabaseTypes";
import { PatientForm } from "@/dentlab/src/forms/form-components/patient/insert-update/patient.form";
import { PatientCoreForm } from "@/dentlab/src/forms/form-components/patient/insert-update/patient-core.form";
import { PatientExtendedForm } from "@/dentlab/src/forms/form-components/patient/insert-update/patient-extended.form";
import { PatientJobs } from "@/dentlab/src/store/Sheets/sheet-contents/patient-sheet/components/PatientJobs";
import {
	Collapsible,
	CollapsibleContent,
	CollapsibleTriggerStandard,
} from "@/dentlab/src/components/ui/collapsible";
import { usePatientStore } from "@/dentlab/src/store/Patient";

interface KeeperPatientPanelProps {
	patient: PatientEntityType;
}

// Same content as the patient sheet, rendered inline on the merge selection
// page for the staying patient.
export const KeeperPatientPanel: React.FC<KeeperPatientPanelProps> = ({
	patient,
}) => {
	const patientName = usePatientStore((state) => state.patientName);
	const [coreOpen, setCoreOpen] = useState(false);
	const [extendedOpen, setExtendedOpen] = useState(false);
	const [jobHistoryOpen, setJobHistoryOpen] = useState(true);

	return (
		<div className="flex flex-col">
			<div className="flex flex-row items-end gap-2 pb-4">
				<div className="text-lg font-bold">{patientName(patient)}</div>
				<div className="text-md text-gray-700">
					{patient.code ?? ""}
				</div>
				<div className="text-md text-gray-700">
					{patient.birth_date
						? new Date(patient.birth_date).toLocaleDateString(
								"de-DE"
							)
						: ""}
				</div>
			</div>
			<PatientForm patientId={patient.id} withinSheet>
				<Collapsible
					open={coreOpen}
					onOpenChange={setCoreOpen}
					className="border-b-0"
				>
					<CollapsibleTriggerStandard
						open={coreOpen}
						className="text-md"
					>
						<div>Patientendaten</div>
					</CollapsibleTriggerStandard>
					<CollapsibleContent>
						<PatientCoreForm autoFocusCode={false} />
					</CollapsibleContent>
				</Collapsible>
				<Collapsible open={extendedOpen} onOpenChange={setExtendedOpen}>
					<CollapsibleTriggerStandard
						open={extendedOpen}
						className="text-md"
					>
						<div>Weitere Patientendaten</div>
					</CollapsibleTriggerStandard>
					<CollapsibleContent>
						<PatientExtendedForm />
					</CollapsibleContent>
				</Collapsible>
			</PatientForm>
			<Collapsible
				open={jobHistoryOpen}
				onOpenChange={setJobHistoryOpen}
				className="border-t-0"
			>
				<CollapsibleTriggerStandard
					open={jobHistoryOpen}
					className="text-md"
				>
					<div>Historie</div>
				</CollapsibleTriggerStandard>
				<CollapsibleContent>
					<PatientJobs patientId={patient.id} />
				</CollapsibleContent>
			</Collapsible>
		</div>
	);
};
